import Mousetrap from "mousetrap";
import { useEffect } from "react";

export const useMouseTrap = (ref, keyHandlerMap, dependencies = []) => {
  useEffect(() => {
    if (
      ref?.current &&
      keyHandlerMap &&
      Object.keys(keyHandlerMap).length > 0
    ) {
      const mouseTrap = new Mousetrap(ref.current);
      Object.entries(keyHandlerMap).forEach(([key, handler]) => {
        mouseTrap.bind(key.split(","), handler);
      });

      return () => {
        Object.keys(keyHandlerMap).forEach((key) => {
          mouseTrap.unbind(key.split(","));
        });
      };
    }
  }, [ref.current, ...dependencies]);
};
